import React from "react";
import { FANTASY_WEEKS } from "../services/iplSchedule";

// Build a lookup from week number → label (e.g. "Wk 3 · 5 Apr – 10 Apr")
const weekInfo = Object.fromEntries(FANTASY_WEEKS.map(w => [w.week, w.label]));

const weekLabel = (w) => weekInfo[w] || `Week ${w}`;
const weekShort = (w) => weekInfo[w] ? `Week ${w}` : `Week ${w}`;

export function WeekPicker({ week, setWeek, min = 1, max = 12 }) {
  const weeks = [];
  for (let w = min; w <= max; w++) weeks.push(w);

  return (
    <div className="week-picker">
      <button
        type="button"
        className="mini"
        disabled={week <= min}
        onClick={() => setWeek(week - 1)}
      >
        ←
      </button>
      <div className="week-label" style={{ flexDirection: "column", alignItems: "center", gap: 1 }}>
        <span>{weekShort(week)}</span>
        {weekInfo[week] && (
          <span style={{ fontSize: 10, color: "var(--text-dim)", fontWeight: 400 }}>
            {weekInfo[week].replace(/^Wk \d+ · /, "")}
          </span>
        )}
      </div>
      <button
        type="button"
        className="mini"
        disabled={week >= max}
        onClick={() => setWeek(week + 1)}
      >
        →
      </button>
      <select
        value={week}
        onChange={(e) => setWeek(Number(e.target.value))}
        style={{ marginLeft: 8 }}
      >
        {weeks.map((w) => (
          <option key={w} value={w}>{weekLabel(w)}</option>
        ))}
      </select>
    </div>
  );
}
